import React, { useState, useEffect } from "react";
import { Box, Grid, InputAdornment, TextField } from "@mui/material";
import { Search } from "tabler-icons-react";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { fetchTabManagement } from "../../redux/actions/tabManagementActionCreators";
import axiosInstance from "../../axios";
import DataTable from "./DataTable";
import { Autocomplete } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import DetailsModal from "./DetailsModal";
import Accordion from "./Accordion";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  const isMobile = useMediaQuery("(max-width:1400px)");

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ width: "100%" }}
    >
      {value === index && (
        <Box sx={{ width: "100%", mt: !isMobile ? 7 : 3 }}>{children}</Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const SuperManagement = () => {
  const isAuth = useSelector((state) => state.user.isAuth);
  const tabManagement = useSelector((state) => state.tabManagement.all);
  const totalPages = useSelector((state) => state.tabManagement.totalPages);
  const enterprises = useSelector((state) => state.tabManagement.enterprises);

  const isMobile = useMediaQuery("(max-width:1400px)");
  const sm = useMediaQuery("(max-width:755px)");

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const [searchText, setSearchText] = useState("");
  const [tab, setTab] = useState(0);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [type, setType] = useState("");
  const [enterpriseFilter, setEnterpriseFilter] = useState("");
  const [status, setStatus] = useState("");
  const [userDetails, setUserDetails] = useState({});
  const [canAccessManagement, setCanAccessManagement] = useState(false);
  const [accessChecked, setAccessChecked] = useState(false);

  useEffect(() => {
    let isActive = true;

    axiosInstance
      .get("/auth/get_user")
      .then((res) => {
        if (!isActive) return;
        const allowed = res?.data?.role === "cytailor_admin";
        setCanAccessManagement(allowed);
        setAccessChecked(true);
        if (!allowed) {
          history.replace("/enterprise");
        }
      })
      .catch(() => {
        if (!isActive) return;
        setCanAccessManagement(false);
        setAccessChecked(true);
        history.replace("/enterprise");
      });

    return () => {
      isActive = false;
    };
  }, [history]);

  useEffect(() => {
    if (canAccessManagement) {
      dispatch(
        fetchTabManagement(page, searchText, enterpriseFilter, status, type)
      );
    }
  }, [
    dispatch,
    canAccessManagement,
    page,
    searchText,
    enterpriseFilter,
    status,
    type,
  ]);

  if (!accessChecked) {
    return null;
  }

  const handleClose = () => {
    setOpen(false);
  };

  const handleTabs = (event, value) => {
    setTab(value);
    setPage(1);
    if (value === 0) {
      setType("");
    } else if (value === 1) {
      setType("enterprise");
    } else {
      setType("free");
    }
  };

  const handlePage = (pageNumber) => {
    setPage(pageNumber);
  };

  const handeleUserDetails = (user) => {
    setUserDetails(user);
    setOpen(true);
  };

  const head = [
    { align: "left", value: t("username"), width: "20%" },
    { align: "left", value: t("email_address"), width: "30%" },
    { align: "left", value: t("account_type"), width: "20%" },
    { align: "left", value: t("creation_date"), width: "20%" },
    { align: "left", value: t("action"), width: "10%" },
  ];

  const OrgaHead = [
    { align: "left", value: t("username"), width: "25%" },
    { align: "left", value: t("email_address"), width: "30%" },
    { align: "left", value: t("account_type"), width: "20%" },
    { align: "left", value: t("creation_date"), width: "25%" },
  ];

  return (
    <Box
      sx={{
        display: !isAuth && "flex",
        flexDirection: !isAuth && "column",
        height: !isAuth && "100%",
        alignContent: "space-between",
        gap: 5,
      }}
    >
      <Box
        sx={{ padding: !isMobile ? "0px 54px" : "0px 15px" }}
        mt={isMobile ? 2 : 6}
      >
        <Grid container spacing={2} mt={0}>
          <Grid item sm={12} xs={12} md={8}>
            <TextField
              fullWidth
              id="outlined-start-adornment"
              placeholder={t("search")}
              onChange={(e) => {
                setSearchText(e.target.value);
                setPage(1);
              }}
              value={searchText}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {" "}
                    <Search size={22} strokeWidth={2} color="#8F9BB2" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item sm={6} xs={12} md={2}>
            <FormControl fullWidth>
              <InputLabel>{t("filter_by")}</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label={t("filter_by")}
                value={status}
                style={{ height: "auto" }}
                onChange={(e) => {
                  setStatus(e.target.value);
                  setPage(1);
                }}
              >
                <MenuItem value={""}>{t("all_status")}</MenuItem>
                <MenuItem value={true}>{t("actived")}</MenuItem>
                <MenuItem value={false}>{t("desactivated")}</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item sm={6} xs={12} md={2}>
            <Autocomplete
              value={enterpriseFilter}
              name="enterpriseOrganisation"
              onChange={(e, value) => {
                setEnterpriseFilter(value);
                setPage(1);
              }}
              id="tags-standard"
              options={enterprises}
              getOptionLabel={(option) => option}
              fullWidth
              renderInput={(params) => (
                <TextField {...params} label={t("filter_by_enterprise")} />
              )}
            />
          </Grid>
        </Grid>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            mt: 5,
            width: "100%",
          }}
        >
          <Tabs
            value={tab}
            onChange={handleTabs}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
          >
            <Tab label={t("all")} {...a11yProps(0)} />
            <Tab label={t("enterprises")} {...a11yProps(1)} />
            <Tab label={t("organizations")} {...a11yProps(2)} />
          </Tabs>
        </Box>
        <TabPanel value={tab} index={0} sx={{ width: "100%" }}>
          {sm ? (
            <Accordion
              head={head}
              rows={tabManagement}
              handlePage={handlePage}
              totalPages={totalPages}
              handeleUserDetails={handeleUserDetails}
              page={page}
              searchText={searchText}
              enterprise={enterpriseFilter}
              status={status}
              type={type}
            />
          ) : (
            <DataTable
              head={head}
              rows={tabManagement}
              handlePage={handlePage}
              totalPages={totalPages}
              handeleUserDetails={handeleUserDetails}
              page={page}
              searchText={searchText}
              enterprise={enterpriseFilter}
              status={status}
              type={type}
            />
          )}
        </TabPanel>
        <TabPanel value={tab} index={1} sx={{ width: "100%" }}>
          {sm ? (
            <Accordion
              head={head}
              rows={tabManagement}
              handlePage={handlePage}
              totalPages={totalPages}
              handeleUserDetails={handeleUserDetails}
              page={page}
              searchText={searchText}
              enterprise={enterpriseFilter}
              status={status}
              type={type}
            />
          ) : (
            <DataTable
              head={head}
              rows={tabManagement}
              handlePage={handlePage}
              totalPages={totalPages}
              handeleUserDetails={handeleUserDetails}
              page={page}
              searchText={searchText}
              enterprise={enterpriseFilter}
              status={status}
              type={type}
            />
          )}
        </TabPanel>
        <TabPanel value={tab} index={2} sx={{ width: "100%" }}>
          {sm ? (
            <Accordion
              head={OrgaHead}
              rows={tabManagement}
              handlePage={handlePage}
              totalPages={totalPages}
              handeleUserDetails={handeleUserDetails}
              page={page}
              searchText={searchText}
              enterprise={enterpriseFilter}
              status={status}
              type={type}
            />
          ) : (
            <DataTable
              head={OrgaHead}
              rows={tabManagement}
              handlePage={handlePage}
              totalPages={totalPages}
              handeleUserDetails={handeleUserDetails}
              page={page}
              searchText={searchText}
              enterprise={enterpriseFilter}
              status={status}
              type={type}
            />
          )}
        </TabPanel>

        <br />
      </Box>
      <DetailsModal
        open={open}
        handleClose={handleClose}
        userDetails={userDetails}
        handeleUserDetails={handeleUserDetails}
        page={page}
        searchText={searchText}
        enterprise={enterpriseFilter}
        status={status}
        type={type}
      />
    </Box>
  );
};

export default SuperManagement;
